/* eslint-disable @typescript-eslint/naming-convention */
import { Injectable } from '@angular/core';
import { listToDictionary, ProjectModel } from '@shared';
import { cloneDeep } from 'lodash';
import { WorkspaceDatabaseKeys } from '../../workspace-database/schemas/workspace-database-keys';

@Injectable()
export class JsonFileDataParser {
	private PROJECT_KEY = 'PROJECT';
	private referenceTableDictionary: { [key: number]: any[] };

	public extractProjectsList(referenceTables: any[]): ProjectModel[] {
		if (!referenceTables) {
			throw new Error('JSON file contents are invalid. There are no reference tables');
		}

		this.referenceTableDictionary = listToDictionary(WorkspaceDatabaseKeys.referenceTableName, referenceTables);
		const projectList = cloneDeep(this.referenceTableDictionary[this.PROJECT_KEY]);

		if (!projectList) {
			throw new Error('JSON file contents are invalid. Project list must exist in the reference tables');
		}
		return projectList;
	}

	public extractReferenceTablesDict(): { [key: number]: any[] } {
		if (!this.referenceTableDictionary) {
			throw new Error('List not initialized. Please call extractProjectsList first');
		}
		return this.referenceTableDictionary;
	}
}
